import { useEffect, useState } from "react";
import axiosWithAuth from "../utils/axiosWithAuth";
import { getOrderTaxSummary } from "../utils/orderTaxes";

export default function useOrderTaxSummary(order) {
  const businessID = order?.businesses_id ?? order?.business_id ?? order?.restaurant_id;
  const recordedRate = getOrderTaxSummary(order).rate;
  const [loaded, setLoaded] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (recordedRate === null && businessID) {
      axiosWithAuth().get(`/api/business/${businessID}`)
        .then(({ data }) => {
          if (!cancelled) setLoaded({ id: businessID, data });
        })
        .catch(() => {
          if (!cancelled) setLoaded({ id: businessID, data: null });
        });
    }
    return () => { cancelled = true; };
  }, [businessID, recordedRate]);

  return getOrderTaxSummary(order, loaded && loaded.id === businessID ? loaded.data : undefined);
}
